import { computed, type ComputedRef } from 'vue'

/**
 * Visibility flags for CPRootContainer sidebar and content.
 * Account settings and exhibitor center (desktop): portal sidebar is always forced collapsed (icon-only, 3rem) so the
 * inner surface gets the full width. The collapse toggle is hidden on these routes,
 * so users cannot expand the sidebar while there. On navigation away the sidebar
 * restores to whatever the user's previous collapsed/expanded state was.
 * Account settings (mobile): no portal drawer; dedicated TopBarMobile handles this route.
 * Exhibitor center (mobile): no portal drawer.
 */
export function useCPRootVisibility(
  isNonCPNavigationRoute: ComputedRef<boolean>,
  isMobile: { value: boolean },
  isAuthPage: ComputedRef<boolean>,
  isAccountSettingsPage: ComputedRef<boolean>,
  isExhibitorCenterPage: ComputedRef<boolean>
) {
  const showPortalSidebar = computed(() => !isMobile.value && !isAuthPage.value)

  const showSidebarToggleBar = computed(
    () =>
      !isNonCPNavigationRoute.value && !isMobile.value && !isAuthPage.value && !isAccountSettingsPage.value && !isExhibitorCenterPage.value
  )

  const showPortalMobileDrawer = computed(
    () => isMobile.value && !isAuthPage.value && !isAccountSettingsPage.value && !isExhibitorCenterPage.value
  )

  const showTopBar = computed(() => !isMobile.value && !isAuthPage.value)

  const showMobileTopBar = computed(() => isMobile.value && !isAuthPage.value)

  return {
    showPortalSidebar,
    showSidebarToggleBar,
    showPortalMobileDrawer,
    showTopBar,
    showMobileTopBar,
  }
}
